import React from "react";

function AboutSection() {
  return (
    <div>
      <div className="about-section style-three magic-cursor">
        <div className="divider"></div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-sm-9 col-md-8 col-lg-6">
              <div className="section-heading text-center">
                <div className="sub-title justify-content-center text-white">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  About Us
                </div>
                <h2 className="text-white">
                  Your Trusted Advocates in the Legal Landscape
                </h2>
              </div>
            </div>
          </div>

          <div className="row g-4 lawgis-filter">
            {/* Left Column */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="row g-4">
                {/* Top Left - About Card pic 1*/}
                <div className="col-12 filter-item">
                  <div className="about-card">
                    <img src="assets/img/bg-img/60.jpg" alt="" />
                  </div>
                </div>
                
                {/* Bottom Left - Successful Case Card (moved up) */}
                <div className="col-12 filter-item">
                  <div className="about-card move-up">
                    <div className="about-card bg-primary small-card">
                      <div className="d-flex align-items-center justify-content-between gap-3">
                        <div className="text-dark">Successful Case</div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                        >
                          <path
                            d="M36.2826 28.005L22.8034 16.0352L20.1694 18.6692L32.1392 32.1484C33.2638 33.4239 35.226 33.4842 36.426 32.2842C37.626 31.0842 37.5581 29.122 36.2826 28.005Z"
                            fill="white"
                          />
                          <path
                            d="M20.1659 30.9612C20.1659 29.6102 19.0716 28.5234 17.7282 28.5234H7.79612C6.45275 28.5234 5.3584 29.6102 5.3584 30.9612V32.048H20.1659V30.9612Z"
                            fill="white"
                          />
                          <path
                            d="M20.3677 32.8008H5.15257C3.80919 32.8008 2.71484 33.8876 2.71484 35.2385V37.1631C2.71484 37.6234 3.0922 38.0008 3.55257 38.0008H21.9677C22.4356 38.0008 22.8054 37.6234 22.8054 37.1631V35.2385C22.8054 33.8876 21.7111 32.8008 20.3677 32.8008Z"
                            fill="white"
                          />
                          <path
                            d="M9.90234 13.457L17.6052 5.7542L24.8022 12.9512L17.0993 20.654L9.90234 13.457Z"
                            fill="white"
                          />
                          <path
                            d="M25.487 12.5795C26.1956 13.2882 27.3427 13.2882 28.0514 12.5795C28.7601 11.8708 28.7601 10.7238 28.0514 10.0151L20.5632 2.52697C20.2089 2.1726 19.7427 1.99544 19.281 2.00009C18.8194 1.99544 18.3532 2.1726 17.9988 2.52697C17.2901 3.23572 17.2901 4.38267 17.9988 5.09142L25.487 12.5795Z"
                            fill="white"
                          />
                          <path
                            d="M14.1525 23.9122C14.8612 24.6209 16.0082 24.6209 16.7169 23.9122C17.4256 23.2034 17.4255 22.0564 16.7169 21.3477L9.22878 13.8597C8.87441 13.5053 8.40815 13.3281 7.95123 13.3281C7.48497 13.3281 7.01871 13.5053 6.66434 13.8597C5.95564 14.5684 5.95564 15.7154 6.66434 16.4241L14.1525 23.9122Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <p className="mb-0 text-dark">
                        Aliquam eu nunc imperdiet, volut, lobortis ligula. pharetra
                        dignissim lacus, faucibus volutpat lorem suscipit nec.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Middle Column - Big Card */}
            <div className="col-12 col-md-6 col-lg-4 filter-item">
              <div className="about-card big-card full-height">
                <img src="assets/img/bg-img/61.jpg" alt="" />
                {/* Top Content */}
                <div className="top-conetnt">
                  <div>
                    <span className="counter">6000</span>+
                  </div>
                  <p className="mb-0">Trusted Clients</p>
                </div>
                {/* Bottom Content */}
                <div className="bottom-content">
                  <div>Successful Case</div>
                  <p className="mb-0">
                    Our attorneys bring extensive experience and specialized
                    knowledge in areas of law.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="row g-4">
                {/* Top Right - Best Attorneys Card */}
                <div className="col-12 filter-item">
                  <div className="about-card small-card">
                    <div className="d-flex align-items-center justify-content-between gap-3">
                      <div>Best Attorneys</div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                      >
                        <path
                          d="M32.5387 36.6487H7.48041C4.97541 36.6487 3.04207 34.7587 3.37041 32.2754L3.56041 30.827C3.90541 28.827 5.73541 27.5687 7.72207 27.137L19.8804 24.9987H20.1204L32.2787 27.137C34.2987 27.6037 36.0954 28.792 36.4404 30.827L36.6304 32.2937C36.9587 34.777 35.0254 36.6654 32.5204 36.6654L32.5387 36.6487ZM28.3337 11.6654C28.3337 13.8755 27.4558 15.9951 25.893 17.5579C24.3302 19.1207 22.2105 19.9987 20.0004 19.9987C17.7903 19.9987 15.6707 19.1207 14.1079 17.5579C12.545 15.9951 11.6671 13.8755 11.6671 11.6654C11.6671 9.45523 12.545 7.33561 14.1079 5.77281C15.6707 4.21 17.7903 3.33203 20.0004 3.33203C22.2105 3.33203 24.3302 4.21 25.893 5.77281C27.4558 7.33561 28.3337 9.45523 28.3337 11.6654Z"
                          stroke="white"
                          strokeOpacity="0.3"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <p className="mb-0">
                      Aliquam eu nunc imperdiet, volut, lobortis ligula. pharetra
                      dignissim lacus, faucibus volutpat lorem suscipit nec.
                    </p>
                  </div>
                </div>
                
                {/* Bottom Right - About Card pic 2 */}
                <div className="col-12 filter-item">
                  <div className="about-card">
                    <img src="assets/img/bg-img/62.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </div>
    </div>
  );
}

export default AboutSection;